import { ICoord } from "../models/coord.model";
import { ISearchParamsCache } from "../models/search-params-cache.model";
import { DEFAULT_PAGE_SIZE } from "./listing-search.constants";

export const listingsSearchParamsToApi = (searchParams: ISearchParamsCache, forcedSearchParams: ISearchParamsCache, geo_poly: ICoord[], page?: number) => {

  const price_min = searchParams.listPriceRangeLow === undefined ? null : Number(searchParams.listPriceRangeLow);
  const price_max = searchParams.listPriceRangeHigh === undefined ? null : Number(searchParams.listPriceRangeHigh);
  const prop_status = searchParams.status === undefined ? [] : JSON.parse(searchParams.status);
  const prop_type = searchParams.propType === undefined ? [] : JSON.parse(searchParams.propType);

  // forced search params if exist
  const geo_city = forcedSearchParams.geo_city === undefined ? '' : forcedSearchParams.geo_city;
  const geo_state = forcedSearchParams.geo_state === undefined ? '' : forcedSearchParams.geo_state;
  const geo_street_no = forcedSearchParams.geo_street_no === undefined ? '' : forcedSearchParams.geo_street_no;
  const geo_street = forcedSearchParams.geo_street === undefined ? '' : forcedSearchParams.geo_street;
  const geo_street_suffix = forcedSearchParams.geo_street_suffix === undefined ? '' : forcedSearchParams.geo_street_suffix;
  const geo_community = forcedSearchParams.geo_community === undefined ? '' : forcedSearchParams.geo_community;

  const jsonObject: {
    [key: string]: string | number | boolean | ICoord[] | null;
  } = {
    page_num: !page ? 1 : page,
    page_size: DEFAULT_PAGE_SIZE,
    price_min,
    price_max,
    prop_status,
    prop_type,
    geo_city,
    geo_state,
    geo_street_no,
    geo_street,
    geo_street_suffix,
    geo_community,
    geo_poly
  }

  const queryString = Object.keys(jsonObject)
  .map((key) => {
    const value = jsonObject[key];
    if (value !== null) {
      if (Array.isArray(value)) {
        // Convert the array to a string representation
        const arrayValue = JSON.stringify(value);
        return `${encodeURIComponent(key)}=${encodeURIComponent(arrayValue)}`;
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    }
    return '';
  })
  .filter((param) => param !== '')
  .join('&');

  return queryString;

};